import React ,{useState} from 'react'
import './errors-and-omissions-insurance.scss'
import {
    Hero, MainHeading,
    Breadcrumb, CommonTabs,
    SentryCard, Plans,
    NewsCard, SuccessStories,
    FindAgent,
    PageHeaderIntro
} from '../../../../components';
import { images } from "../../../../utils/customFn";
import { Container } from 'react-bootstrap';

const ErrorsOmissionsInsurance = () => {
    const [hrefData, setHrefData] = useState();
    const breadcrumbs = [
        { label: "Sentry Insurance home", link: "/" },
        { label: "What we offer", link: "/what-we-offer" },
        { label: "Insurance products", link: "/what-we-offer/insurance-products" },
        { label: "General liability insurance", link: "/what-we-offer/insurance-products/general-liability-insurance" },
        { label: "Errors and omissions insurance", link: "/what-we-offer/insurance-products/general-liability-insurance/errors-and-omissions-insurance" },
    ];

    const activeTabId = "difference";

    const tabsData = [
        {
            id: "difference",
            href: "difference",
            label: "The Sentry difference",
        },
        {
            id: "omissionscoverage",
            href: "omissionscoverage",
            label: "Types of errors and omissions coverage",
        },
        {
            id: "help",
            href: "help",
            label: "Who we've helped",
        },
    ];

    const sectrydata = {
        banner: images['two_business_people_looking_at_tablet.avif'],
        heading: 'The Sentry difference',
        subheading: 'Different drivers—different coverages',
        para: 'We’ll work with you to determine what liability insurance coverage is appropriate for your organization. Our goal is to help make sure you’re protected from the actual exposures and risks your business faces.',
        sideheading: 'The right coverage for your business',
        sidepara: 'We draw on our insurance experience and leverage our industry knowledge to help you protect your business and your future.',
        sideImg: images['boots_Blue.svg']
    }
    const plansData = {
        blue_heading: 'Specific E&O policies and coverages',
        blue_para: 'Our errors and omissions coverages are tailored to industries we know and have had success working with. Don’t see your business or industry represented here? Don’t worry, we can tailor an E&O policy that makes sense for you. We’ll work with you to protect the business you’ve worked so hard to build. Click on your industry below to learn what our errors and omissions coverage can do for you. Or contact an agent to learn more about how we can help protect your business from costly mistakes.',
        purple_icon: images['Icon_of_two_purple_chairs.svg'],
        purple_heading: 'Our claims specialists are industry-specific',
        purple_para: "When you file a claim, you’ll be assigned a claims specialist who’s knowledgeable about your industry and your policy type.",
    }
    const NewsCardData = [
        {
            id: 1,
            title: 'Commercial auto insurance',
            description:
                'We have the 401(k) and other retirement plan options and services to help you and your employees plan for retirement.',
            linkUrl: '',
            linkText: 'More about commercial auto insurance >',
        },
        {
            id: 2,
            title: 'Dealership auto coverage',
            description: 'Running a business comes with uncertainties. Protect yourself from the unknown with business liability coverage.',
            linkUrl: '/',
            linkText: 'More about dealership auto coverage >',
        },
        {
            id: 3,
            title: 'Commercial auto liability',
            description:
                'Protect your profits and property from the unexpected during a construction or renovation project.',
            linkUrl: '/',
            linkText: 'More about commercial auto liability >',
        },

    ];
    const HeaderData = [
        {
            image: images['two-people-carrying-canoe.svg'],
            para: 'Our general liability insurance can cover damages related to bodily injury or property damage. Increase your liability protection with our errors and omissions (E&O) coverage, which addresses the unique exposures of contractors, agricultural consultants, dealers, and manufacturers. When it comes to liability, nobody wants to be held accountable for oversights. Our E&O coverage can be there when a mistake leaves you liable for damages.',
        },
    ];
    return (
        <>
            <div className='errors-and-omissions-insurance'>
                {/* hero section */}
                <Hero img={images["hero-errors-omissions-two-men-meeting-large.avif"]} />
                <Container>
                    {/* Breadcrumb */}
                    <Breadcrumb crumbs={breadcrumbs} />
                    {/* heading  */}
                    <MainHeading title="Errors and omissions insurance" showshare={false} />
                    {/* Tabs */}
                    <CommonTabs tabs={tabsData} activeTab={activeTabId} hrefData={hrefData}
                    setHrefData={setHrefData} />

                    {/* Header intro section */}
                    <PageHeaderIntro Data={HeaderData} heading="" />

                    {/* the sentry card */}
                    {/* <SentryCard data={sectrydata} /> */}
                    {/* Plans section */}
                    <div className='the-sentry-card' id='difference'>
                        <h1>The Sentry difference</h1>
                        <Plans data={plansData} />
                    </div>
                    {/* news card section */}
                    <NewsCard id='omissionscoverage' Title="Errors and omissions coverage by industry" CardData={NewsCardData} showNavLink={false} subTitle="PRODUCTS" />
                    {/* success stories */}
                    <SuccessStories showSeemore={true} id='help'/>
                    {/* news  */}
                    <NewsCard Title="News and resources" CardData={NewsCardData} showNavLink={false} subTitle="GUIDES" />
                    <FindAgent />
                </Container>
            </div>
        </>
    )
}

export default ErrorsOmissionsInsurance